import { Grid, Hidden, Typography } from '@mui/material';
import Header from 'components/Header';
import { FC } from 'react';
import { getProfileName } from 'utils/global';
import Logo from 'components/Logo';
import { Profile } from 'use/profiles';
import { LogoBox, HeaderBox } from './documentHeader.style';

type DocumentHeaderTemplateProps = {
  sectionName: string;
  commercialRelation?: string | null;
  profiles?: Profile[] | undefined;
};

const DocumentHeaderTemplate: FC<DocumentHeaderTemplateProps> = ({
  sectionName,
  commercialRelation,
  profiles,
}) => {
  const moneyLenderName = getProfileName(profiles, commercialRelation);

  return (
    <Header>
      <Hidden smDown>
        <HeaderBox width="100%">
          <Grid container direction="row" alignItems="center" mb={2}>
            <LogoBox>
              <Logo label={commercialRelation} size="M" isTitle={false} />
            </LogoBox>
            <Grid>
              <Typography data-testid="header-title" variant="h4">
                {sectionName}
              </Typography>
              <Typography data-testid="header-moneyLenderName" variant="body1">
                {moneyLenderName}
              </Typography>
            </Grid>
          </Grid>
        </HeaderBox>
      </Hidden>
      <Hidden smUp>
        <Typography data-testid="header-title-mobile" variant="h5">
          {sectionName}
        </Typography>
      </Hidden>
    </Header>
  );
};

export default DocumentHeaderTemplate;
